// ============================================================
// Events Module — Router (index.tsx)
// Lazy-loads all sub-routes for the Events module.
// Angular source: EventsModule
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const DcEvent = lazy(() => import('./dc-event/DcEvent'));
const StateEvent = lazy(() => import('./state-event/StateEvent'));

const EventsModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="dc-event" element={<DcEvent />} />
        <Route path="state-event" element={<StateEvent />} />
      </Routes>
    </Suspense>
  );
};

export default EventsModule;
